import React from 'react';
import { values } from 'lodash-es';
import GridRowContainer from 'shared/lib/extendedComponents/grids/components/gridRowContainer';
import { Box } from '@mui/material';
import {
  ExplorerEntityTypes,
  SortContentKey,
  SortContentOrder,
  getActualSortContentMap,
} from 'entities/types';
import CustomSelect from 'shared/lib/components/controls/selects/customSelect';
import SortOrderSelect from 'shared/lib/components/controls/sorting/sortOrderSelect';

export default function MobileContentHeaderRow({
  onChange,
  value,
  supportTypes,
}: {
  supportTypes: ExplorerEntityTypes[];
  onChange?: (params: { key: SortContentKey; order: SortContentOrder }) => void;
  value?: { key: SortContentKey; order: SortContentOrder };
}) {
  if (!onChange || !value) {
    return null;
  }

  return (
    <GridRowContainer sx={{ border: 'none !important' }}>
      <Box
        sx={{ display: 'flex', gap: 3, gridColumnStart: 1, gridColumnEnd: 3 }}
      >
        <SortOrderSelect
          value={value.order}
          onChange={(order) =>
            onChange({
              key: value.key,
              order,
            })
          }
        ></SortOrderSelect>

        <CustomSelect
          value={value.key}
          items={values(getActualSortContentMap({ supportTypes }))}
          onChange={(key) =>
            onChange({
              key,
              order: value.order,
            })
          }
        ></CustomSelect>
      </Box>
    </GridRowContainer>
  );
}
